module.exports = __webpack_public_path__ + "static/media/bell.464c795f.svg";